const nativeExternalLinkBridges = () => {
  if (typeof window === 'undefined') return [];
  return [
    window.TeamLobbyAndroid,
    window.AndroidPlayerApp,
    window.PlayEmpAndroid,
  ].filter(Boolean);
};

export const openExternalUrl = (value) => {
  const href = String(value || '').trim();
  if (!href || typeof window === 'undefined') return false;

  for (const bridge of nativeExternalLinkBridges()) {
    if (typeof bridge?.openExternalUrl !== 'function') continue;
    try {
      if (bridge.openExternalUrl(href) !== false) return true;
    } catch {
      // Older APK bridges fall through to the normal browser behavior.
    }
  }

  if (!/^https?:/i.test(href)) {
    window.location.assign(href);
    return true;
  }

  const opened = window.open(href, '_blank', 'noopener,noreferrer');
  if (opened) return true;

  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  return true;
};
